/**
 * Which time-off requests a time-off bill line is calculated from — matches backend contract.
 *
 * Separate from `BillHoursSourceTypeDTO`: its `APPROVED` means "approved worklog hours" on a
 * project, a different concept from an approved time-off request.
 */
export enum BillTimeOffSourceTypeDTO {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  APPROVED_AND_PENDING = 'APPROVED_AND_PENDING',
}

export type BillTimeOffSourceTypeResponse = BillTimeOffSourceTypeDTO;
